import React from "react";
import { FaCopy, FaDownload, FaUndo } from "react-icons/fa";

const ButtonGroup = ({ messages, setReset }) => {

console.log("buttons", messages)

const handleCopyClick = () => {
  const combinedMessages = messages.map((message, index) => `${index % 2 === 0 ? "ai:" : ""} ${message}`).join('\n');
  navigator.clipboard.writeText(combinedMessages);
};

const handleDownloadClick = () => {
  const combinedMessages = messages.map((message, index) => `${index % 2 === 0 ? "ai:" : ""} ${message}`).join('\n');
  const blob = new Blob([combinedMessages], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'messages.txt';
  a.click();
  URL.revokeObjectURL(url);
};

  const handleUndoClick = () => {
    // Your undo logic here
    console.log("reset in button", setReset)
    setReset(1)
  };

  return (
    <div className="d-flex justify-content-end mt-2">
      <div className="btn-group btn-group-sm" role="group">
        <button type="button" className="btn btn-light" onClick={handleCopyClick}>
          <FaCopy />
        </button>
        <button type="button" className="btn btn-light" onClick={handleDownloadClick}>
          <FaDownload />
        </button>
        <button type="button" className="btn btn-light" onClick={handleUndoClick}>
          <FaUndo />
        </button>
      </div>
    </div>
  );
};

export default ButtonGroup;
